<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import ArrowRight from '@/shared/assets/icons/ArrowRight.svg';

  defineProps({
    item: {
      type: Object,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <li class="flex items-center font-sm gap-1 min-w-0">
    <router-link
      v-if="item.clickable !== false"
      :to="item.path"
      :title="item.name"
      :class="['text-sm truncate max-w-60', isLast ? 'text-gray-07' : 'text-gray-03']"
    >
      {{ item.name }}
    </router-link>
    <span
      v-else
      :title="item.name"
      :class="[
        'text-sm truncate max-w-60',
        isLast ? 'text-gray-07' : 'text-gray-03',
        'cursor-default',
      ]"
    >
      {{ item.name }}
    </span>
    <span
      v-if="!isLast"
      class="text-gray-03 shrink-0"
    >
      <IconImage
        :src="ArrowRight"
        alt="Arrow Right"
        class="w-5 h-5"
      />
    </span>
  </li>
</template>
